<template>
  <el-dialog title="自定义菜单"
             :visible.sync="visible"
             width="720px"
             append-to-body
             @closed="handleClosed"
             :close-on-press-escape="false">
    <custom-menu-tree ref="menu"
                      v-if="visible"
                      :autoLoad="autoLoad"
                      :orgId="options.portalProfileId" />
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CustomMenuTree from './custom-menu-tree.vue'
export default {
  name: 'custom-menu-tree-modal',
  components: { CustomMenuTree },
  props: {
    callback: { type: Function },
    autoLoad: { type: Boolean, default: true }
  },
  data () {
    return {
      visible: false,
      loading: false,
      options: { profileName: '', profileType: '', portalProfileId: null }
    }
  },
  methods: {
    handleClosed () { },
    handleSubmit () {
      const menuNodes = this.$refs.menu.getMenuTrees()
      console.log(menuNodes)
      if (menuNodes.length === 0) {
        this.$message.error('菜单为空')
        return
      }
      this.loading = true
      this.$$CommonApi.configportalprofile({ ...this.options, menuTree: { menuNodes } })
        .then(res => {
          const { result, message } = res.data
          this.loading = false
          if (result === 0) {
            this.$message.success('设置成功')
            this.callback && this.callback()
            this.visible = false
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    init (options = {}, roleFuncs = null) {
      this.options = { ...this.options, ...options }
      this.visible = true
      if (roleFuncs) {
        setTimeout(() => {
          this.$refs.menu.customInit(roleFuncs)
        }, 20)
      }
    }
  }
}
</script>
